import { Breadcrumb } from 'modules/model-json';

export const KITCHEN_PDP_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1693231994/fudzi/elbrus/images/landings/kitchen-pdp';

export const KITCHEN_PDP_ELEMENT_BLOCK = 'komplektyDetail';

export const KITCHEN_PDP_CATEGORY_ID = '1832';

export const KITCHEN_PDP_LANDING_NAME = 'kitchen-pdp';

export const MODIFIED_KITCHEN_PDP_BREADCRUMBS: Breadcrumb[] = [
  {
    label: 'Каталог',
    link: '/catalogue/',
  },
  {
    label: 'Кухни',
    link: '/catalogue/kuhni/',
  },
  {
    label: 'Мебель для кухни',
    link: '/catalogue/mebel-dlya-kuhni/',
  },
  {
    label: 'Готовые комплекты кухонь',
    link: '/proekt-kuhni/gotovye/',
  },
];

export const MODIFIED_KITCHEN_PDP_CORNER_BREADCRUMBS: Breadcrumb[] = [
  ...MODIFIED_KITCHEN_PDP_BREADCRUMBS,
  {
    label: 'Угловые кухонные гарнитуры',
    link: '/proekt-kuhni/gotovye/uglovye/',
  },
];
